<template>
  <div class="p-0 m-0 table-container">
    <table-header
      :title="'Smsy wysłane do użytkownika'"
      :withPagination="true"
      :dispatchAction="'fetchSmsListForUser'"
      :onPage="this.smsList.on_page"
      :pageNumber="this.smsList.page_number"
      :total="this.smsList.total"
      :firstAdditionalButton="
        userById.user_profile.user.disabled_sms_notifications
          ? 'Włącz powiadomienia sms'
          : 'Wyłącz powiadomienia sms'
      "
      :refreshAction="true"
      @firstMethodToListen="
        handleSms(userById.user_profile.user.disabled_sms_notifications)
      "
    ></table-header>

    <button
      type="button"
      class="addNewButton"
      data-toggle="modal"
      data-target="#addNewSms"
      @click="setUserPhone()"
    >
      Wyślij SMS
    </button>

    <table
      class="table table-striped"
      v-if="this.smsList && this.smsList.list && this.smsList.list.length > 0"
    >
      <thead>
        <tr class="tr-table">
          <th scope="col">ID</th>
          <th scope="col">Data wysłania</th>
          <th scope="col">Wysyłający admin</th>
          <th scope="col">Wysłano do</th>
          <th scope="col">Wiadomość</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="sms in smsList.list" :key="sms.id">
          <td>{{ sms.id }}</td>
          <td>
            {{ sms.creationDate ? formattedDate(sms.creationDate) : "" }}
          </td>
          <td>{{ sms.sender.phone }}</td>
          <td v-if="sms.receiver">{{ sms.receiver.phone }}</td>
          <td v-else>
            <p v-if="sms.phone_number">{{ sms.phone_number }}</p>
            <button
              v-if="sms.phone_numbers && sms.phone_numbers.length > 0"
              type="button"
              class="btn btn-outline-dark"
              data-toggle="modal"
              data-target="#phoneNumbers"
              @click="setGroupPhoneNumbersToShow(sms.phone_numbers)"
            >
              Lista numerów
            </button>
          </td>
          <td>{{ sms.message }}</td>
          <div
            class="modal fade"
            id="phoneNumbers"
            tabindex="-1"
            role="dialog"
            aria-labelledby="phoneNumbers"
            aria-hidden="true"
          >
            <div class="modal-dialog modal-xl" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="phoneNumbers">Lista numerów</h5>
                  <button
                    type="button"
                    class="close"
                    data-dismiss="modal"
                    aria-label="Close"
                  >
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body">
                  <span
                    v-for="number in groupSmses"
                    :key="number"
                    style="margin-right: 1rem"
                    >{{ number }}
                  </span>
                </div>

                <div class="modal-footer">
                  <button
                    type="button"
                    class="btn btn-outline-dark"
                    data-dismiss="modal"
                  >
                    Zamknij
                  </button>
                </div>
              </div>
            </div>
          </div>
        </tr>
      </tbody>
    </table>

    <div
      class="modal fade"
      id="addNewSms"
      tabindex="-1"
      role="dialog"
      aria-labelledby="addNewSms"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-xl" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="addNewSms">Nowy sms</h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <form class="addNewSmsForm" @submit.prevent="sendSms()">
              <div class="input-container">
                <input
                  v-model="phoneNumber"
                  id="title"
                  class="form-control"
                  type="text"
                  required
                  minlength="9"
                  maxlength="9"
                  placeholder="Numer telefonu"
                  disabled
                />
              </div>
              <div class="input-container">
                <textarea
                  v-model="message"
                  id="message"
                  class="form-control"
                  type="text"
                  required
                  minlength="1"
                  maxlength="1024"
                  placeholder="Wiadomość..."
                />
              </div>

              <button class="buttonm btn btn-outline-dark w-100" type="submit">
                Wyślij
              </button>
            </form>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-outline-dark"
              data-dismiss="modal"
            >
              Zamknij
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import shared from "../shared";
import TableHeader from "../components/TableHeader";
import axios from "../axios";
export default {
  name: "SmsList",
  components: { TableHeader },

  data() {
    return {
      phoneNumber: "",
      message: "",
      groupSmses: [],
    };
  },

  created() {
    this.$store.dispatch("fetchSmsListForUser", {
      search_param: this.$attrs.id,
      page_number: 1,
      on_page: 20,
    });

    this.formattedDate = shared.formattedDateAsNumbers;
  },
  destroyed() {
    this.$store.dispatch("setNullToSmsList");
  },
  methods: {
    setGroupPhoneNumbersToShow(smses) {
      this.groupSmses = smses;
    },
    handleSms(decision) {
      if (!decision) {
        decision = false;
      }
      axios
        .put(
          `api/user/${this.userById.user_profile.user.id}/smsNotifications?allow_sms=${decision}`
        )
        .then(() => {
          this.$store.dispatch("getUserById", {
            userId: this.userById.user_profile.user.id,
          });
        });
    },
    sendSms() {
      axios
        .post(`api/smsFromAdmin/${this.phoneNumber}`, {
          message: this.message,
        })
        .then(() => {
          this.$notify({
            group: "success",
            text: "Pomyślnie wysłano wiadomość",
          });
          this.$store.dispatch("fetchSmsListForUser", {
            search_param: this.$attrs.id,
            page_number: this.smsList.page_number,
            on_page: this.smsList.on_page,
          });
          this.message = "";
        })
        .catch((err) => {
          console.log(err.response.data.error);
          if (err.response.data.error === "not_found_user") {
            this.$notify({
              group: "error",
              text: "Nie istnieje użytkownik o podanym numerze",
            });
          } else {
            this.$notify({
              group: "error",
              text: "Nie udało się wysłać wiadomości",
            });
          }
        });
    },
    setUserPhone() {
      if (this.$route.params.id) {
        this.phoneNumber = this.userById.user_profile.user.phone;
      }
    },
  },

  computed: {
    smsList() {
      return this.$store.getters.getSmsList;
    },
    userById() {
      return this.$store.getters.getUserById;
    },
  },
};
</script>

<style scoped></style>
